<template>
  <Modal v-model="touristPriceConfigModal" :title="$t('key1001846')" width="700" :transfer="false"
    :mask-closable="false" @on-visible-change="touristPriceConfigChange">
    <div class="flex flex-wrap mb20">
      <div class="width_110">{{ $t('key1002408') }}</div>
      <RadioGroup v-model="touristPricesType">
        <Radio v-for="item in priceDisplayTypeList" :label="item.value" class="mr35">{{ item.name }}</Radio>
      </RadioGroup>
    </div>
    <template #footer>
      <Button @click="touristPriceConfigModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="touristPriceConfigBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'touristPriceConfigModal',
  mixins: [Mixin],
  props: {
    touristPricesTypeList: {
      type: Array,
      default: () => []
    },
    showProductWholesaleModel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let v = this;
    return {
      touristPriceConfigModal: false,
      touristPricesType: 'hidePrice',
      configParamKey: null
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    priceDisplayTypeList() {
      if (this.showProductWholesaleModel) {
        return this.touristPricesTypeList;
      } else {
        return this.touristPricesTypeList.filter(i => i.value !== 'showWholesalePrice');
      }
    }
  },
  methods: {
    // 初始化数据
    iniTouristPriceConfigData(paramKey, paramValue) {
      if (paramValue) {
        this.touristPricesType = paramValue;
      }
      this.configParamKey = paramKey;
      this.touristPriceConfigModal = true;
    },
    // 确定按钮
    touristPriceConfigBtn() {
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: this.configParamKey,
          paramValue: this.touristPricesType,
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
        this.touristPriceConfigModal = false;
        this.$emit('updateConfigData', true);
      });
    },
    // 监听弹窗
    touristPriceConfigChange(value) {
      if (!value) {
        this.touristPricesType = 'hidePrice';
        this.configParamKey = null;
      }
    }
  }
};
</script>

<style lang="less">

</style>
